import React, { useState } from "react";
import { Row, Col, Card, Table, Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { FaPlus, FaRedo, FaFilter, FaSort, FaSearch, FaEdit, FaTrashAlt } from "react-icons/fa";

const initialData = [
  {
    partnerName: "Asif",
    planName: "Plan Alpha",
    expiry: "2024-01-01",
    lastRenewal: "2023-12-01",
    nextRenewal: "2024-12-01",
  },
  {
    partnerName: "Bilal",
    planName: "Plan Beta",
    expiry: "2023-05-01",
    lastRenewal: "2023-04-01",
    nextRenewal: "2023-05-01",
  },
  {
    partnerName: "Cynthia",
    planName: "Plan Gamma",
    expiry: "2024-07-01",
    lastRenewal: "2023-06-01",
    nextRenewal: "2024-06-01",
  },
];

const AutoPayTable = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter(
    (item) =>
      item.partnerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.planName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setData(sortedData);
  };

  const handleEdit = (index) => {
    alert(`Edit action for row ${index + 1}`);
  };

  const handleCancel = (index) => {
    alert(`Cancel action for row ${index + 1}`);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Button variant="primary" className="d-flex align-items-center">
                <FaPlus className="me-2" /> AutoPay
              </Button>
              <div className="d-flex align-items-center">
                <Button variant="light" className="me-2">
                  <FaFilter />
                </Button>
                <Button variant="light" className="me-2">
                  <FaRedo />
                </Button>
                <InputGroup style={{ width: "300px" }}>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="rounded"
                  />
                </InputGroup>
              </div>
            </Card.Header>
            <Card.Body>
              <div
                className="table-responsive border border-secondary rounded"
                style={{ padding: "1rem" }}
              >
                <Table hover>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("partnerName")}>
                        Partner Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("planName")}>
                        Plan Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("expiry")}>
                        Expiry <FaSort />
                      </th>
                      <th onClick={() => handleSort("lastRenewal")}>
                        Last Renewal <FaSort />
                      </th>
                      <th onClick={() => handleSort("nextRenewal")}>
                        Next Renewal <FaSort />
                      </th>
                      <th>Edit</th>
                      <th>Cancel</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          border: "1px solid #ddd",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        <td className="d-flex align-items-center">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              backgroundColor: "#007bff",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginRight: "10px",
                            }}
                          >
                            {item.partnerName[0]}
                          </div>
                          {item.partnerName}
                        </td>
                        <td>{item.planName}</td>
                        <td>{item.expiry}</td>
                        <td>{item.lastRenewal}</td>
                        <td>{item.nextRenewal}</td>
                        <td>
                          <Button
                            variant="light"
                            className="rounded-circle p-2"
                            onClick={() => handleEdit(index)}
                          >
                            <FaEdit />
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="light"
                            className="rounded-circle p-2"
                            onClick={() => handleCancel(index)}
                          >
                            <FaTrashAlt className="text-danger" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {!filteredData.length && (
                  <p className="text-center">No results found.</p>
                )}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {startIndex + 1} to{" "}
                    {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
                    {filteredData.length} entries
                  </div>
                  <div>
                    {[...Array(pageCount).keys()].map((page) => (
                      <Button
                        key={page}
                        variant="light"
                        className={`me-1 ${
                          currentPage === page + 1 ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page + 1)}
                      >
                        {page + 1}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AutoPayTable;
